import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useGetCredentialFromGroupingId } from './hooks';

export function RedirectToFormPreview() {
  const { loading, groupingIdInt, credentialTypeId, formId } = useGetCredentialFromGroupingId();
  const history = useHistory();

  useEffect(() => {
    if (!loading) {
      history.push(`/credential-type/${credentialTypeId}/groupings/${groupingIdInt}/forms/${formId}/preview`);
    }
  }, [loading]);

  return (
    <div className="alert alert-primary" role="alert">
      Redirecting to path with CredentialTypeID as param...
    </div>
  );
}

export function RedirectToFormEdition() {
  const { loading, groupingIdInt, credentialTypeId, formId } = useGetCredentialFromGroupingId();
  const history = useHistory();

  useEffect(() => {
    if (!loading) {
      history.push(`/credential-type/${credentialTypeId}/groupings/${groupingIdInt}/forms/${formId}`);
    }
  }, [loading]);

  return (
    <div className="alert alert-primary" role="alert">
      Redirecting to path with CredentialTypeID as param...
    </div>
  );
}

export function RedirectToFormBuilder() {
  const { loading, groupingIdInt, credentialTypeId } = useGetCredentialFromGroupingId();
  const history = useHistory();

  useEffect(() => {
    if (!loading) {
      history.push(`/credential-type/${credentialTypeId}/groupings/${groupingIdInt}/forms/form-builder`);
    }
  }, [loading]);

  return (
    <div className="alert alert-primary" role="alert">
      Redirecting to path with CredentialTypeID as param...
    </div>
  );
}

export function RedirectToFormList() {
  const { loading, groupingIdInt, credentialTypeId } = useGetCredentialFromGroupingId();
  const history = useHistory();

  useEffect(() => {
    if (!loading) {
      history.push(`/credential-type/${credentialTypeId}/groupings/${groupingIdInt}/forms`);
    }
  }, [loading]);

  return (
    <div className="alert alert-primary" role="alert">
      Redirecting to path with CredentialTypeID as param...
    </div>
  );
}
